import script from "./CommonStream.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonStream.vue?vue&type=script&setup=true&lang=js"

import "./CommonStream.vue?vue&type=style&index=0&id=3860c2f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3860c2f3"]])

export default __exports__